import { useFormattedOfferedMaxTerms } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import { trackOpenWithFaireOwfGlobalUpsellBannerClick } from "@faire/web-api--source/events/openWithFaire/click/owfGlobalUpsellBanner";
import { trackOpenWithFaireOwfGlobalUpsellBannerView } from "@faire/web-api--source/events/openWithFaire/view/owfGlobalUpsellBanner";
import openWithFaire from "@faire/web-api--source/routes/www/open-with-faire";
import { MediumFormatting } from "@faire/web/common/localization/formatting";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Medium } from "@faire/web/ui/Typography/Span";
import React, { useEffect, type JSX } from "react";

export const OpenWithFaireEligibleToApplyBanner: React.FC = () => {
  const formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();
  useEffect(() => {
    trackOpenWithFaireOwfGlobalUpsellBannerView();
  }, []);

  return (
    <Typography
      align="center"
      data-test-id="open-with-faire-eligible-to-apply-banner"
    >
      <StrictLocalMsg
        id="wszcOi"
        defaultMessage="Get up to <MediumFormatting>{maxTermsLimitMoney} in payment terms</MediumFormatting> when you apply for Open with Faire. <LinkFormatting>Learn more</LinkFormatting>"
        description={{
          text: "Marketing Open with Faire program to eligible retailers",
        }}
        values={{
          MediumFormatting: MediumFormatting,
          maxTermsLimitMoney: formattedOfferedMaxTerms,
          LinkFormatting: LinkFormatting,
        }}
      />
    </Typography>
  );
};

const LinkFormatting = (chunk: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={openWithFaire()}
    onClick={trackOpenWithFaireOwfGlobalUpsellBannerClick}
  >
    <Medium>{chunk}</Medium>
  </Button>
);
